/* global requestAnimationFrame */
import { applyPreferences } from '../utils/localePreferences'
import { getLocaleFromPath } from '../utils/localeHelpers'
import { getCookie } from '../utils/cookieHelpers'
import { trackAmplitudeEvent } from '../analytics/CustomEvents'

function isMobile () {
  return window.innerWidth <= 599
}

export default function initFooterLocaleSwitcher () {
  const trigger = document.getElementById('vjs-footer-locale-trigger')
  if (!trigger) return

  initTrigger(trigger)
  initMenu(trigger)
  initModal()
}

function initTrigger (trigger) {
  const menu = document.getElementById('vjs-footer-locale-menu')
  const modal = document.getElementById('vjs-footer-locale-modal')

  trigger.addEventListener('click', () => {
    if (isMobile()) {
      if (modal) openModal(modal)
    } else if (menu) {
      menu.classList.toggle('hidden')
    }
  })
}

function initMenu (trigger) {
  const menu = document.getElementById('vjs-footer-locale-menu')
  if (!menu) return

  document.addEventListener('click', e => {
    if (isMobile()) return
    if (!trigger.contains(e.target) && !menu.contains(e.target)) {
      closeMenuAndApplyIfChanged(menu)
    }
  })

  initOptionToggling(menu)
}

function initModal () {
  const modal = document.getElementById('vjs-footer-locale-modal')
  if (!modal) return

  modal.addEventListener('click', e => {
    if (e.target === modal) closeModal(modal)
  })

  const applyBtn = modal.querySelector('.vjs-footer-locale-modal-apply')
  if (applyBtn) {
    applyBtn.addEventListener('click', () => applyModalSelections(modal))
  }

  initOptionToggling(modal)
}

function applyModalSelections (modal) {
  const language = getSelectedValue(modal, 'language')
  const currency = getSelectedValue(modal, 'currency')
  applyPreferences(language, currency)
  trackAmplitudeEvent('Locale Selector Option Applied', {
    'Chosen Language': language,
    'Chosen Currency': currency.toUpperCase()
  })
}

function openModal (modal) {
  const panel = modal.querySelector('.vjs-footer-locale-modal-panel')
  modal.classList.add('show')
  requestAnimationFrame(() => {
    if (panel) {
      panel.classList.remove('translate-y-full')
      panel.classList.add('translate-y-0')
    }
  })
}

function closeModal (modal) {
  const panel = modal.querySelector('.vjs-footer-locale-modal-panel')
  if (panel) {
    panel.classList.remove('translate-y-0')
    panel.classList.add('translate-y-full')
    panel.addEventListener('transitionend', () => {
      modal.classList.remove('show')
    }, { once: true })
  } else {
    modal.classList.remove('show')
  }
}

function initOptionToggling (container) {
  const options = container.querySelectorAll('.vjs-footer-locale-option')
  options.forEach(option => {
    option.addEventListener('click', () => {
      const group = option.dataset.group
      const groupOptions = container.querySelectorAll(`.vjs-footer-locale-option[data-group="${group}"]`)
      groupOptions.forEach(other => setOptionSelected(other, false))
      setOptionSelected(option, true)
    })
  })
}

function setOptionSelected (option, isSelected) {
  option.dataset.selected = String(isSelected)

  const check = option.querySelector('.vjs-footer-locale-check')
  if (check) check.classList.toggle('hidden', !isSelected)

  option.classList.toggle('bg-midnight-black-5', isSelected)
}

function closeMenuAndApplyIfChanged (menu) {
  if (menu.classList.contains('hidden')) return
  menu.classList.add('hidden')

  const selectedLanguage = getSelectedValue(menu, 'language')
  const selectedCurrency = getSelectedValue(menu, 'currency')
  // Read the active locale from the server-rendered body attribute rather than the URL — a
  // user with a sticky non-default preference can be on a default-locale URL (no prefix), in
  // which case the URL alone would falsely report the default locale and skip the change.
  const currentLanguage = document.body.dataset.locale || getLocaleFromPath(window.location.pathname) || 'en'
  const currentCurrency = getCookie('user_currency') || 'gbp'

  if (selectedLanguage !== currentLanguage || selectedCurrency !== currentCurrency) {
    applyPreferences(selectedLanguage, selectedCurrency)
  }
}

function getSelectedValue (container, group) {
  const selected = container.querySelector(`.vjs-footer-locale-option[data-group="${group}"][data-selected="true"]`)
  return selected ? selected.dataset.value : ''
}
